import { TimeTranslation } from '@/lib/format';

export const translations: TimeTranslation = {
  en: {
    seconds: {
      short: 's',
      long: 'seconds ago',
      shortAgo: 's ago',
    },
    minutes: {
      short: 'm',
      long: 'minutes ago',
      shortAgo: 'm ago',
    },
    hours: {
      short: 'h',
      long: 'hours ago',
      shortAgo: 'h ago',
    },
    days: {
      short: 'd',
      long: 'days ago',
      shortAgo: 'd ago',
    },
    months: {
      short: 'mo',
      long: 'months ago',
      shortAgo: 'mon ago',
    },
    years: {
      short: 'y',
      long: 'years ago',
      shortAgo: 'y ago',
    },
  },
  'zh-CN': {
    seconds: {
      short: '秒',
      long: '秒前',
      shortAgo: '秒前',
    },
    minutes: {
      short: '分',
      long: '分钟前',
      shortAgo: '分钟前',
    },
    hours: {
      short: '时',
      long: '小时前',
      shortAgo: '小时前',
    },
    days: {
      short: '天',
      long: '天前',
      shortAgo: '天前',
    },
    months: {
      short: '月',
      long: '个月前',
      shortAgo: '个月前',
    },
    years: {
      short: '年',
      long: '年前',
      shortAgo: '年前',
    },
  },
  'zh-HK': {
    seconds: {
      short: '秒',
      long: '秒前',
      shortAgo: '秒前',
    },
    minutes: {
      short: '分',
      long: '分鐘前',
      shortAgo: '分鐘前',
    },
    hours: {
      short: '時',
      long: '小時前',
      shortAgo: '小時前',
    },
    days: {
      short: '天',
      long: '天前',
      shortAgo: '天前',
    },
    months: {
      short: '月',
      long: '個月前',
      shortAgo: '個月前',
    },
    years: {
      short: '年',
      long: '年前',
      shortAgo: '年前',
    },
  },
};
